import { AppError } from './error'

/** HTTP failures must not start another expensive query. */
export function retryRead(failureCount: number, error: Error): boolean {
  if (error.name === 'AbortError') return false
  if (error instanceof AppError && error.status >= 400) return false
  return failureCount < 1
}
